// Generated by CoffeeScript 1.12.7
(function() {
  var _;

  _ = require('underscore');

  module.exports = function(secureImagesUrl, imagesUrlPrefix) {
    if (imagesUrlPrefix == null) {
      imagesUrlPrefix = 'http://static%d.artsy.net';
    }
    return {
      defaultImageVersion: function() {
        if (this.has('image_versions' || this.has('versions'))) {
          return (this.get('image_versions') || this.get('versions'))[0];
        } else {
          return null;
        }
      },
      missingImageUrl: function() {
        return "/images/missing_image.png";
      },
      hasImage: function(version) {
        return _.contains(this.get('image_versions'), version) || _.contains(this.get('versions'), version) || version === 'original';
      },
      imageUrl: function(version) {
        var ref;
        if (version == null) {
          version = this.defaultImageVersion();
        }
        if (this.hasImage(version)) {
          return this.sslUrl(this.get('image_url').replace(':version', version));
        } else if ((ref = this.get('image_versions')) != null ? ref.length : void 0) {
          return this.sslUrl(this.get('image_url').replace(':version', this.get('image_versions')[0]));
        } else {
          return this.missingImageUrl();
        }
      },
      bestImageUrl: function(versions) {
        var i, len, version;
        if (versions == null) {
          versions = [];
        }
        for (i = 0, len = versions.length; i < len; i++) {
          version = versions[i];
          if (this.hasImage(version)) {
            return this.imageUrl(version);
          }
        }
        return this.imageUrl();
      },
      sslUrl: function(url) {
        if (!(secureImagesUrl && imagesUrlPrefix)) {
          return url;
        }
        if (this.imagesUrlPrefixRE == null) {
          this.imagesUrlPrefixRE = new RegExp(imagesUrlPrefix.replace('%d', '\\d'));
        }
        return url.replace(this.imagesUrlPrefixRE, secureImagesUrl);
      }
    };
  };

}).call(this);
